import React, { useState, useEffect } from 'react';
import TurnstileWidget from './TurnstileWidget';
import './RegisterPage.css';

// Ті самі обов'язкові поля, що перевіряє сервер (крок форми → поля)
const REQUIRED_FIELDS = {
  Model: {
    2: ['firstName', 'lastName', 'dateOfBirth', 'nationality', 'languages', 'address'],
    3: ['height', 'hairColor', 'eyeColor', 'bodyType', 'professionalBio', 'fashionExperience', 'skills', 'education'],
  },
  Creative: {
    2: ['firstName', 'lastName', 'nationality', 'languages', 'city', 'country'],
    3: ['professionalBio', 'yearsOfExperience', 'skills', 'education', 'workplace', 'location', 'portfolioWebsite'],
  },
  Company: {
    2: ['companyName', 'businessType', 'contactPerson', 'city', 'country'],
    3: ['companyDescription', 'servicesOffered', 'yearsOfExperience', 'companyWebsite'],
  },
  Entrepreneur: {
    2: ['firstName', 'lastName', 'companyName', 'businessType', 'city', 'country'],
    3: ['businessDescription', 'visionMission', 'yearsOfExperience', 'companyWebsite'],
  },
};
const roleGroup = (role) =>
  role === 'Model' ? 'Model' : ['Agency', 'Brand'].includes(role) ? 'Company' : role === 'Entrepreneur' ? 'Entrepreneur' : 'Creative';
const FIELD_LABELS = {
  firstName: 'First Name', lastName: 'Last Name', dateOfBirth: 'Date of Birth', nationality: 'Nationality',
  languages: 'Languages', address: 'Address', city: 'City', country: 'Country', companyName: 'Company Name',
  businessType: 'Type of Business', contactPerson: 'Contact Person', height: 'Height', hairColor: 'Hair Color',
  eyeColor: 'Eye Color', bodyType: 'Body Type', professionalBio: 'Professional Bio', fashionExperience: 'Fashion Experience',
  skills: 'Skills', education: 'Education', yearsOfExperience: 'Years of Experience', workplace: 'Current Company',
  location: 'Work Location', portfolioWebsite: 'Portfolio Website', companyDescription: 'Company Description',
  servicesOffered: 'Services Offered', companyWebsite: 'Company Website', businessDescription: 'Business Description',
  visionMission: 'Vision / Mission',
};
function RegisterPage({ onNavigate }) {
    const [currentStep, setCurrentStep] = useState(1);
    const [isVIP, setIsVIP] = useState(false);
    const [vipPassword2, setVipPassword2] = useState('');
    const [showPw, setShowPw] = useState(false);
    const [tsToken, setTsToken] = useState('');
    const [tsKey, setTsKey] = useState(0);    
    const [formData, setFormData] = useState({
        // Step 1: Role
        userRole: '',
        
        // Step 2: Basic Info
        firstName: '',
        lastName: '',
        dateOfBirth: '',
        age: '',
        nationality: '',
        languages: '',
        address: '',
        city: '',
        country: '',
        
        // Company fields (Agency/Brand/Entrepreneur)
        companyName: '',
        businessType: '',
        contactPerson: '',
        
        // Step 3: Professional Info
        professionalBio: '',
        creativeVision: '',
        yearsOfExperience: '',
        notableProjects: '',
        skills: '',
        education: '',
        fashionExperience: '',
        workplace: '',
        location: '',
        portfolioWebsite: '',
        linkedin: '',
        companyDescription: '',
        servicesOffered: '',
        notableClients: '',
        companyWebsite: '',
        businessDescription: '',
        visionMission: '',
        
        // Physical (Models only)
        height: '',
        hairColor: '',
        eyeColor: '',
        bodyType: '',
        
        // Step 4: Contacts & Account
        email: '',
        password: '',
        phone: '',
        telegram: '',
        instagram: ''
    });

    useEffect(() => {
        // Check if VIP registration
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('vip') === 'true') {
            setIsVIP(true);
        }
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        if (name === 'dateOfBirth') {
            const birthYear = new Date(value).getFullYear();
            const currentYear = new Date().getFullYear();
            const calculatedAge = currentYear - birthYear;
            
            setFormData(prev => ({
                ...prev,
                dateOfBirth: value,
                age: calculatedAge.toString()
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

const validateStep = () => {
  if (currentStep === 1 && !formData.userRole) {
    alert('Please select your role');
    return false;
  }
  if (currentStep === 2 || currentStep === 3) {
    const required = REQUIRED_FIELDS[roleGroup(formData.userRole)][currentStep] || [];
    const missing = required.filter((f) => !String(formData[f] || '').trim());
    if (missing.length) {
      alert('Please fill in: ' + missing.map((f) => FIELD_LABELS[f] || f).join(', '));
      return false;
    }
  }
  if (currentStep === 4) {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(formData.email.trim())) {
      alert('Please enter a valid email address');
      return false;
    }
    const pw = formData.password;
    if (pw.length < 8 || !/[A-Za-z]/.test(pw) || !/\d/.test(pw)) {
      alert('Password must be at least 8 characters and contain letters and digits');
      return false;
    }
    if (!formData.phone.trim() || !formData.telegram.trim()) {
      alert('Please fill in Phone and Telegram');
      return false;
    }
  }
  return true;
};

    const nextStep = () => {
        if (validateStep()) {
            setCurrentStep(prev => prev + 1);
            window.scrollTo(0, 0);
        }
    };

    const prevStep = () => {
        setCurrentStep(prev => prev - 1);
        window.scrollTo(0, 0);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!validateStep()) return;
        if (!tsToken) { alert('Please complete the security check'); return; }
        try {
            const response = await fetch('https://orkxz4jpah.execute-api.us-east-1.amazonaws.com/register', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ...formData,
                    registrationSource: isVIP ? 'vip' : 'direct',
                    turnstileToken: tsToken
                })
            });
            
            const result = await response.json();
            
            if (result.success) {
                alert(`Registration successful! Your Genesis ID: ${result.genesisID}\nCheck your email for confirmation.`);
                onNavigate('home');
            } else {
                alert(`Registration failed: ${result.error}`);
                setTsKey((k) => k + 1);
            }
        } catch (error) {
            console.error('Network error:', error);
            alert(`Network error: ${error.message}`);
        }
    };

const handleVIPSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.firstName || !formData.lastName || !formData.email || !formData.phone) {
        alert('Please fill in all required fields');
        return;
    }
    if (formData.password.length < 8 || !/[A-Za-z]/.test(formData.password) || !/\d/.test(formData.password)) {
        alert('Password must be at least 8 characters and contain letters and digits');
        return;
    }
    if (formData.password !== vipPassword2) {
        alert('Passwords do not match');
        return;
    }
        if (!tsToken) {
        alert('Please complete the security check');
        return;
    }    
    try {
        const response = await fetch('https://orkxz4jpah.execute-api.us-east-1.amazonaws.com/register', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                firstName: formData.firstName,
                lastName: formData.lastName,
                email: formData.email,
                phone: formData.phone,
                linkedin: formData.linkedin || '',
                userRole: formData.userRole || 'Pending',
                password: formData.password,
                registrationSource: 'vip',
                turnstileToken: tsToken
            })
        });
        
        const result = await response.json();
        
        if (result.success) {
        alert(`✅ VIP Registration Successful!\n\nYour Genesis ID: ${result.genesisID}\n\nWelcome to Genesis by THEO!\n\nLog in with this Genesis ID and the password you created. We also sent your Genesis ID to your email.`);
            onNavigate('login'); // Краще перекинути на login
        } else {
            alert(`Registration failed: ${result.message || result.error}`);
            setTsKey((k) => k + 1);
        }
    } catch (error) {
        console.error('Network error:', error);
        alert(`Network error: ${error.message}`);
    }
};


    // VIP Registration Form
    if (isVIP) {
        return (
            <div className="register-container">
                <div className="register-form vip-form">
                    <div className="register-header">
                        <h2>VIP Registration</h2>
                        <p>Express registration for invited guests</p>
                    </div>
                    
                    <form onSubmit={handleVIPSubmit}>
                        <div className="form-section">
                            <div className="form-row">
                                <div className="form-group">
                                    <label>First Name *</label>
                                    <input
                                        type="text"
                                        name="firstName"
                                        placeholder="Enter your first name"
                                        value={formData.firstName}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                
                                <div className="form-group">
                                    <label>Last Name *</label>
                                    <input
                                        type="text"
                                        name="lastName"
                                        placeholder="Enter your last name"
                                        value={formData.lastName}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>
                            
                            <div className="form-group">
                                <label>Email *</label>
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Your email address"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            
                            <div className="form-group">
                                <label>Phone *</label>
                                <input
                                    type="tel"
                                    name="phone"
                                    placeholder="Your phone number"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            
                            <div className="form-group">
                                <label>LinkedIn</label>
                                <input
                                    type="text"
                                    name="linkedin"
                                    placeholder="LinkedIn profile URL"
                                    value={formData.linkedin}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>Password *</label>
                                    <input
                                        type={showPw ? 'text' : 'password'}
                                        name="password"
                                        placeholder="Create a password"
                                        value={formData.password}
                                        onChange={handleChange}
                                        required
                                        minLength="8"
                                        autoComplete="new-password"
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Repeat Password *</label>
                                    <input
                                        type={showPw ? 'text' : 'password'}
                                        placeholder="Repeat password"
                                        value={vipPassword2}
                                        onChange={(e) => setVipPassword2(e.target.value)}
                                        required
                                        minLength="8"
                                        autoComplete="new-password"
                                    />
                                </div>
                            </div>
                            <small className="helper-text" style={{ display: 'block', marginTop: '-10px', marginBottom: '15px' }}>
                                Minimum 8 characters, letters and digits
                            </small>
                                                        <button type="button" onClick={() => setShowPw(!showPw)}
                                style={{ background: 'none', border: 'none', color: '#667eea', fontSize: '13px', cursor: 'pointer', padding: 0, marginBottom: '15px' }}>
                                {showPw ? '🙈 Hide password' : '👁 Show password'}
                            </button>                            
                            <div className="form-group">
                                <label>Role (optional)</label>
                                <select
                                    name="userRole"
                                    value={formData.userRole}
                                    onChange={handleChange}
                                >
                                    <option value="">Select role</option>
                                    <option value="Executive">Executive</option>
                                    <option value="Investor">Investor</option>
                                    <option value="Partner">Partner</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                        </div>
                        <div style={{ padding: '0 40px' }}>
                            <TurnstileWidget key={tsKey} onToken={setTsToken} />
                        </div>                        
                        <div className="form-actions">
                            <button type="button" className="btn-back" onClick={() => onNavigate('home')}>
                                ← Back to Home
                            </button>
                            <button type="submit" className="btn-register">
                                Create VIP Account
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }

    // Regular Multi-step Registration Form
    return (
        <div className="register-container">
            <div className="register-form">
                <div className="register-header">
                    <h2>Create Your Genesis Profile</h2>
                    <p>Build your digital identity in the fashion & creative industry</p>
                </div>
                
                {/* Progress Bar */}
                {currentStep > 1 && (
                    <div className="progress-bar">
                        <div className={`progress-step ${currentStep >= 1 ? 'completed' : ''}`}>
                            <div className="step-circle">1</div>
                            <span>Role</span>
                        </div>
                        <div className={`progress-line ${currentStep >= 2 ? 'completed' : ''}`}></div>
                        <div className={`progress-step ${currentStep >= 2 ? 'completed' : ''} ${currentStep === 2 ? 'active' : ''}`}>
                            <div className="step-circle">2</div>
                            <span>Basic Info</span>
                        </div>
                        <div className={`progress-line ${currentStep >= 3 ? 'completed' : ''}`}></div>
                        <div className={`progress-step ${currentStep >= 3 ? 'completed' : ''} ${currentStep === 3 ? 'active' : ''}`}>
                            <div className="step-circle">3</div>
                            <span>Professional</span>
                        </div>
                        <div className={`progress-line ${currentStep >= 4 ? 'completed' : ''}`}></div>
                        <div className={`progress-step ${currentStep === 4 ? 'active' : ''}`}>
                            <div className="step-circle">4</div>
                            <span>Account</span>
                        </div>
                    </div>
                )}
                
                <form onSubmit={handleSubmit}>
                    {/* STEP 1: SELECT ROLE */}
                    {currentStep === 1 && (
                        <div className="form-section role-selection">
                            <h3>Select Your Role</h3>
                            <p className="step-description">Choose the option that best describes you</p>
                            
                            <div className="role-grid">
                                {[
                                    { value: 'Model', icon: '🎭', label: 'Model' },
                                    { value: 'Designer', icon: '✂️', label: 'Fashion Designer' },
                                    { value: 'Photographer', icon: '📷', label: 'Photographer' },
                                    { value: 'Stylist', icon: '👔', label: 'Stylist' },
                                    { value: 'MUA', icon: '💄', label: 'Makeup Artist' },
                                    { value: 'Agency', icon: '🏢', label: 'Agency' },
                                    { value: 'Brand', icon: '🏷️', label: 'Brand' },
                                    { value: 'Creative', icon: '🎨', label: 'Creative Professional' },
                                    { value: 'Entrepreneur', icon: '💼', label: 'Entrepreneur' },
                                    { value: 'Other', icon: '✨', label: 'Other' }
                                ].map(role => (
                                    <div
                                        key={role.value}
                                        className={`role-card ${formData.userRole === role.value ? 'selected' : ''}`}
                                        onClick={() => setFormData(prev => ({ ...prev, userRole: role.value }))}
                                    >
                                        <div className="role-icon">{role.icon}</div>
                                        <div className="role-label">{role.label}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* STEP 2: BASIC INFORMATION */}
                    {currentStep === 2 && (
                        <div className="form-section">
                            <h3>Basic Information</h3>
                            
                            {/* MODEL */}
                            {formData.userRole === 'Model' && (
                                <>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>First Name *</label>
                                            <input
                                                type="text"
                                                name="firstName"
                                                placeholder="Enter your first name"
                                                value={formData.firstName}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        
                                        <div className="form-group">
                                            <label>Last Name *</label>
                                            <input
                                                type="text"
                                                name="lastName"
                                                placeholder="Enter your last name"
                                                value={formData.lastName}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Date of Birth *</label>
                                            <input
                                                type="date"
                                                name="dateOfBirth"
                                                value={formData.dateOfBirth}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        
                                        <div className="form-group">
                                            <label>Age (auto)</label>
                                            <input
                                                type="text"
                                                name="age"
                                                placeholder="Auto-calculated"
                                                value={formData.age}
                                                readOnly
                                                disabled
                                                className="auto-field"
                                            />
                                        </div>
                                    </div>
                                    
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Nationality *</label>
                                            <input
                                                type="text"
                                                name="nationality"
                                                placeholder="Your nationality"
                                                value={formData.nationality}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        
                                        <div className="form-group">
                                            <label>Languages *</label>
                                            <input
                                                type="text"
                                                name="languages"
                                                placeholder="Languages you speak"
                                                value={formData.languages}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Address *</label>
                                        <input
                                            type="text"
                                            name="address"
                                            placeholder="Your full address"
                                            value={formData.address}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </>
                            )}
                            
                            {/* CREATIVE ROLES */}
                            {['Designer', 'Photographer', 'Stylist', 'MUA', 'Creative', 'Other'].includes(formData.userRole) && (
                                <>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>First Name *</label>
                                            <input
                                                type="text"
                                                name="firstName"
                                                placeholder="Enter your first name"
                                                value={formData.firstName}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        
                                        <div className="form-group">
                                            <label>Last Name *</label>
                                            <input
                                                type="text"
                                                name="lastName"
                                                placeholder="Enter your last name"
                                                value={formData.lastName}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Nationality *</label>
                                            <input
                                                type="text"
                                                name="nationality"
                                                placeholder="Your nationality"
                                                value={formData.nationality}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        
                                        <div className="form-group">
                                            <label>Languages *</label>
                                            <input
                                                type="text"
                                                name="languages"
                                                placeholder="Languages you speak"
                                                value={formData.languages}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>City *</label>
                                            <input
                                                type="text"
                                                name="city"
                                                placeholder="Your city"
                                                value={formData.city}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        
                                        <div className="form-group">
                                            <label>Country *</label>
                                            <input
                                                type="text"
                                                name="country"
                                                placeholder="Your country"
                                                value={formData.country}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                            
                            {/* AGENCY / BRAND */}
                            {['Agency', 'Brand'].includes(formData.userRole) && (
                                <>
                                    <div className="form-group">
                                        <label>Company Name *</label>
                                        <input
                                            type="text"
                                            name="companyName"
                                            placeholder="Your company name"
                                            value={formData.companyName}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Type of Business *</label>
                                        <input
                                            type="text"
                                            name="businessType"
                                            placeholder="e.g., Modeling Agency, Fashion Brand"
                                            value={formData.businessType}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Contact Person Name *</label>
                                        <input
                                            type="text"
                                            name="contactPerson"
                                            placeholder="Primary contact person"
                                            value={formData.contactPerson}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>City *</label>
                                            <input
                                                type="text"
                                                name="city"
                                                placeholder="Company location"
                                                value={formData.city}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        
                                        <div className="form-group">
                                            <label>Country *</label>
                                            <input
                                                type="text"
                                                name="country"
                                                placeholder="Country"
                                                value={formData.country}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                            
                            {/* ENTREPRENEUR */}
                            {formData.userRole === 'Entrepreneur' && (
                                <>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>First Name *</label>
                                            <input
                                                type="text"
                                                name="firstName"
                                                placeholder="Enter your first name"
                                                value={formData.firstName}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        
                                        <div className="form-group">
                                            <label>Last Name *</label>
                                            <input
                                                type="text"
                                                name="lastName"
                                                placeholder="Enter your last name"
                                                value={formData.lastName}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Company Name *</label>
                                        <input
                                            type="text"
                                            name="companyName"
                                            placeholder="Your company name"
                                            value={formData.companyName}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Type of Business *</label>
                                        <input
                                            type="text"
                                            name="businessType"
                                            placeholder="What does your business do?"
                                            value={formData.businessType}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>City *</label>
                                            <input
                                                type="text"
                                                name="city"
                                                placeholder="Your city"
                                                value={formData.city}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        
                                        <div className="form-group">
                                            <label>Country *</label>
                                            <input
                                                type="text"
                                                name="country"
                                                placeholder="Your country"
                                                value={formData.country}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    )}

                    {/* STEP 3: PROFESSIONAL INFORMATION */}
                    {currentStep === 3 && (
                        <div className="form-section">
                            <h3>Professional Information</h3>
                            
                            {/* MODEL */}
                            {formData.userRole === 'Model' && (
                                <>
                                    <h4 className="subsection-title">Physical Attributes</h4>
                                    
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Height *</label>
                                            <input
                                                type="text"
                                                name="height"
                                                placeholder="e.g. 5'8'' or 175cm"
                                                value={formData.height}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        
                                        <div className="form-group">
                                            <label>Hair Color *</label>
                                            <input
                                                type="text"
                                                name="hairColor"
                                                placeholder="Your hair color"
                                                value={formData.hairColor}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Eye Color *</label>
                                            <input
                                                type="text"
                                                name="eyeColor"
                                                placeholder="Your eye color"
                                                value={formData.eyeColor}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        
                                        <div className="form-group">
                                            <label>Body Type *</label>
                                            <input
                                                type="text"
                                                name="bodyType"
                                                placeholder="Your body type"
                                                value={formData.bodyType}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    
                                    <h4 className="subsection-title">Professional Background</h4>
                                    
                                    <div className="form-group">
                                        <label>Professional Bio / About Me *</label>
                                        <textarea
                                            name="professionalBio"
                                            placeholder="Tell us about yourself and your modeling experience"
                                            value={formData.professionalBio}
                                            onChange={handleChange}
                                            rows="4"
                                            maxLength="500"
                                            required
                                        />
                                        <small className="char-counter">{formData.professionalBio.length}/500 characters</small>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Fashion Experience *</label>
                                        <input
                                            type="text"
                                            name="fashionExperience"
                                            placeholder="Your fashion industry experience"
                                            value={formData.fashionExperience}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Skills *</label>
                                        <input
                                            type="text"
                                            name="skills"
                                            placeholder="e.g., Runway, Editorial, Commercial"
                                            value={formData.skills}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Education *</label>
                                        <input
                                            type="text"
                                            name="education"
                                            placeholder="Your educational background"
                                            value={formData.education}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Workplace</label>
                                            <input
                                                type="text"
                                                name="workplace"
                                                placeholder="Current agency or freelance"
                                                value={formData.workplace}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        
                                        <div className="form-group">
                                            <label>Location</label>
                                            <input
                                                type="text"
                                                name="location"
                                                placeholder="Work location"
                                                value={formData.location}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Portfolio Website</label>
                                        <input
                                            type="text"
                                            name="portfolioWebsite"
                                            placeholder="https://your-portfolio.com"
                                            value={formData.portfolioWebsite}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </>
                            )}
                            
                            {/* CREATIVE ROLES */}
                            {['Designer', 'Photographer', 'Stylist', 'MUA', 'Creative', 'Other'].includes(formData.userRole) && (
                                <>
                                    <div className="form-group">
                                        <label>Professional Bio / Summary *</label>
                                        <textarea
                                            name="professionalBio"
                                            placeholder="Describe your professional background in 2-3 sentences"
                                            value={formData.professionalBio}
                                            onChange={handleChange}
                                            rows="4"
                                            maxLength="500"
                                            required
                                        />
                                        <small className="char-counter">{formData.professionalBio.length}/500 characters</small>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Creative Vision</label>
                                        <textarea
                                            name="creativeVision"
                                            placeholder="Your artistic philosophy or mission statement (optional)"
                                            value={formData.creativeVision}
                                            onChange={handleChange}
                                            rows="3"
                                            maxLength="300"
                                        />
                                        <small className="char-counter">{formData.creativeVision.length}/300 characters</small>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Years of Experience *</label>
                                        <select
                                            name="yearsOfExperience"
                                            value={formData.yearsOfExperience}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="">Select experience level</option>
                                            <option value="0-1">0-1 years</option>
                                            <option value="2-5">2-5 years</option>
                                            <option value="6-10">6-10 years</option>
                                            <option value="10+">10+ years</option>
                                        </select>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Notable Projects / Clients</label>
                                        <textarea
                                            name="notableProjects"
                                            placeholder="Major brands, campaigns, or achievements"
                                            value={formData.notableProjects}
                                            onChange={handleChange}
                                            rows="3"
                                        />
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Skills *</label>
                                        <input
                                            type="text"
                                            name="skills"
                                            placeholder="e.g., Creative Direction, Styling, Retouching"
                                            value={formData.skills}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Education *</label>
                                        <input
                                            type="text"
                                            name="education"
                                            placeholder="Your educational background"
                                            value={formData.education}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Current Company / Freelance *</label>
                                            <input
                                                type="text"
                                                name="workplace"
                                                placeholder="Company name or 'Freelance'"
                                                value={formData.workplace}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        
                                        <div className="form-group">
                                            <label>Work Location *</label>
                                            <input
                                                type="text"
                                                name="location"
                                                placeholder="City, Country"
                                                value={formData.location}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Portfolio Website *</label>
                                        <input
                                            type="text"
                                            name="portfolioWebsite"
                                            placeholder="https://your-portfolio.com"
                                            value={formData.portfolioWebsite}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>LinkedIn Profile</label>
                                        <input
                                            type="text"
                                            name="linkedin"
                                            placeholder="https://linkedin.com/in/yourname"
                                            value={formData.linkedin}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </>
                            )}
                            
                            {/* AGENCY / BRAND */}
                            {['Agency', 'Brand'].includes(formData.userRole) && (
                                <>
                                    <div className="form-group">
                                        <label>Company Description *</label>
                                        <textarea
                                            name="companyDescription"
                                            placeholder="Describe your company and what you do"
                                            value={formData.companyDescription}
                                            onChange={handleChange}
                                            rows="4"
                                            required
                                        />
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Services Offered *</label>
                                        <textarea
                                            name="servicesOffered"
                                            placeholder="What services does your company provide?"
                                            value={formData.servicesOffered}
                                            onChange={handleChange}
                                            rows="3"
                                            required
                                        />
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Years in Business *</label>
                                        <select
                                            name="yearsOfExperience"
                                            value={formData.yearsOfExperience}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="">Select years in business</option>
                                            <option value="0-1">0-1 years</option>
                                            <option value="2-5">2-5 years</option>
                                            <option value="6-10">6-10 years</option>
                                            <option value="10+">10+ years</option>
                                        </select>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Notable Clients</label>
                                        <textarea
                                            name="notableClients"
                                            placeholder="Major clients or achievements (optional)"
                                            value={formData.notableClients}
                                            onChange={handleChange}
                                            rows="2"
                                        />
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Company Website *</label>
                                        <input
                                            type="text"
                                            name="companyWebsite"
                                            placeholder="https://your-company.com"
                                            value={formData.companyWebsite}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </>
                            )}
                            
                            {/* ENTREPRENEUR */}
                            {formData.userRole === 'Entrepreneur' && (
                                <>
                                    <div className="form-group">
                                        <label>Business Description *</label>
                                        <textarea
                                            name="businessDescription"
                                            placeholder="What does your business do?"
                                            value={formData.businessDescription}
                                            onChange={handleChange}
                                            rows="4"
                                            required
                                        />
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Vision / Mission *</label>
                                        <textarea
                                            name="visionMission"
                                            placeholder="Your business vision and mission"
                                            value={formData.visionMission}
                                            onChange={handleChange}
                                            rows="3"
                                            required
                                        />
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Years of Experience *</label>
                                        <select
                                            name="yearsOfExperience"
                                            value={formData.yearsOfExperience}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="">Select experience level</option>
                                            <option value="0-1">0-1 years</option>
                                            <option value="2-5">2-5 years</option>
                                            <option value="6-10">6-10 years</option>
                                            <option value="10+">10+ years</option>
                                        </select>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Company Website *</label>
                                        <input
                                            type="text"
                                            name="companyWebsite"
                                            placeholder="https://your-company.com"
                                            value={formData.companyWebsite}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>LinkedIn Profile</label>
                                        <input
                                            type="text"
                                            name="linkedin"
                                            placeholder="https://linkedin.com/in/yourname"
                                            value={formData.linkedin}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                    )}

                    {/* STEP 4: CONTACTS & ACCOUNT */}
                    {currentStep === 4 && (
                        <div className="form-section">
                            <h3>Contacts & Account</h3>
                            
                            <div className="form-group">
                                <label>Email *</label>
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Your email address"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                                <small className="helper-text">Confirmation email will be sent here</small>
                            </div>
                            
                            <div className="form-group">
                                <label>Password *</label>
                                <input
                                    type={showPw ? 'text' : 'password'}
                                    name="password"
                                    placeholder="Create a secure password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    required
                                    minLength="8"
                                />
                                <small className="helper-text">Minimum 8 characters, letters and digits</small>
                                                                <button type="button" onClick={() => setShowPw(!showPw)}
                                    style={{ background: 'none', border: 'none', color: '#667eea', fontSize: '13px', cursor: 'pointer', padding: 0, marginTop: '6px', textAlign: 'left' }}>
                                    {showPw ? '🙈 Hide password' : '👁 Show password'}
                                </button>
                            </div>
                            
                            <div className="form-row">
                                <div className="form-group">
                                    <label>Phone *</label>
                                    <input
                                        type="tel"
                                        name="phone"
                                        placeholder="Your phone number"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                
                                <div className="form-group">
                                    <label>Telegram *</label>
                                    <input
                                        type="text"
                                        name="telegram"
                                        placeholder="@username"
                                        value={formData.telegram}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>
                            
                            <div className="form-group">
                                <label>Instagram</label>
                                <input
                                    type="text"
                                    name="instagram"
                                    placeholder="@username or URL"
                                    value={formData.instagram}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    )}
                    {currentStep === 4 && (
                        <div style={{ padding: '0 40px' }}>
                            <TurnstileWidget key={tsKey} onToken={setTsToken} />
                        </div>
                    )}
                    {/* Navigation Buttons */}
                    <div className="form-actions">
                        {currentStep > 1 ? (
                            <button type="button" className="btn-back" onClick={prevStep}>
                                ← Back
                            </button>
                        ) : (
                            <button type="button" className="btn-back" onClick={() => onNavigate('home')}>
                                ← Back to Home
                            </button>
                        )}
                        
                        {currentStep < 4 ? (
                            <button type="button" className="btn-register" onClick={nextStep}>
                                Continue →
                            </button>
                        ) : (
                            <button type="submit" className="btn-register">
                                Create Genesis Account
                            </button>
                        )}
                    </div>
                </form>
            </div>
        </div>
    );
}

export default RegisterPage;
